import React, {useState} from 'react'
import '../CSS/simple-sidebar.css'
import { Media,
    Container,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText} 
    from 'reactstrap'
import SideBar from '../Img/SideBar.png'
import IcoInicio from '../Img/IconSideBar/Inicio.png'
import IcoDigitalizar from '../Img/IconSideBar/Digitalizar.png'
import IcoConsultar from '../Img/IconSideBar/Consultar.png'
import IcoValidar from '../Img/IconSideBar/Validar.png'
import IcoAdministrador from '../Img/IconSideBar/Administrador.png'
import IcoConfiguracion from '../Img/IconSideBar/Configuracion.png'


const custom ={
    "background-color": "transparent"
  }

const Navigation = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);
    switch (props.tipo) {
        case 'auxiliar':
            return (
                <div style={{backgroundColor:'black', height: '100%'}}>
                <div style={{color:'white', display: 'flex', justifyContent:'center',
                    alignItems:'center', minHeight:'2em'}}>
                        {`Bienvenido(a):`} 
                        </div>
                <div className="text-center pb-3" style={{color:'white', display: 'flex', justifyContent:'center',
                    alignItems:'center', minHeight:'2em'}}>
                        {`${props.usuario}`} 
                        </div>
                    <Navbar dark expand="lg" style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}>
                      <NavbarToggler onClick={toggle} style={{color:'white'}}/>
                      <Collapse isOpen={isOpen} navbar>
                        <Nav vertical className="mr-auto" navbar style={{width:'100%'}}>
                        <NavItem>
                        <a href="/inicio" class="list-group-item text-white">                         
                        <Media object src={IcoInicio} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Inicio
                        </a>
                        </NavItem>
                        <NavItem>
                        <a href="/digitalizar" class="list-group-item text-white">                         
                        <Media object src={IcoDigitalizar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Digitalizar
                        </a>
                        </NavItem>
                        <NavItem>
                        <a href="/configuraciones" class="list-group-item text-white">                         
                        <Media object src={IcoConfiguracion} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Configuración
                        </a>
                        </NavItem>
                        </Nav>
                      </Collapse>
                    </Navbar>
                    </div>
            );

        case 'personal':
            return (
                <div style={{backgroundColor:'black', height: '100%'}}>
                <div style={{color:'white', display: 'flex', justifyContent:'center',
                    alignItems:'center', minHeight:'2em'}}>
                        {`Bienvenido(a):`} 
                        </div>
                <div className="text-center pb-3" style={{color:'white', display: 'flex', justifyContent:'center',
                    alignItems:'center', minHeight:'2em'}}>
                        {`${props.usuario}`} 
                        </div>
                    <Navbar dark expand="lg" style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}>
                      <NavbarToggler onClick={toggle} style={{color:'white'}}/>
                      <Collapse isOpen={isOpen} navbar>
                        <Nav vertical className="mr-auto" navbar style={{width:'100%'}}>
                        <NavItem>
                        <a href="/inicio" class="list-group-item text-white">                         
                        <Media object src={IcoInicio} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Inicio
                        </a>
                        </NavItem>
                        <NavItem>
                        <a href="/digitalizar" class="list-group-item text-white">                         
                        <Media object src={IcoDigitalizar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Digitalizar
                        </a>
                        </NavItem>
                        <NavItem>
                        <a href="/consultar" class="list-group-item text-white">                         
                        <Media object src={IcoConsultar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Consultar
                        </a>
                        </NavItem>
                        <NavItem>
                        <a href="/validar" class="list-group-item text-white">                         
                        <Media object src={IcoValidar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Validar
                        </a>
                        </NavItem>
                        <NavItem>
                        <a href="/configuraciones" class="list-group-item text-white">                         
                        <Media object src={IcoConfiguracion} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                        Configuración
                        </a>
                        </NavItem>
                        </Nav>
                      </Collapse>
                    </Navbar>
                    </div>
            );

        case 'administrador':
            return ( 
                <div style={{backgroundColor:'black', height: '100%'}}>
                <div style={{color:'white', display: 'flex', justifyContent:'center',
                    alignItems:'center', minHeight:'2em'}}>
                        {`Bienvenido(a):`} 
                        </div>
                <div className="text-center pb-3" style={{color:'white', display: 'flex', justifyContent:'center',
                    alignItems:'center', minHeight:'2em'}}>
                        {`${props.usuario}`} 
                        </div>
                            <Navbar dark expand="lg" style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}>
                              <NavbarToggler onClick={toggle} style={{color:'white'}}/>
                              <Collapse isOpen={isOpen} navbar>
                                <Nav vertical className="mr-auto" navbar style={{width:'100%'}}>
                                <NavItem>
                                <a href="/inicio" class="list-group-item text-white">                         
                                <Media object src={IcoInicio} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                                Inicio
                                </a>
                                </NavItem>
                                <NavItem>
                                <a href="/digitalizar" class="list-group-item text-white">                         
                                <Media object src={IcoDigitalizar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                                Digitalizar
                                </a>
                                </NavItem>
                                <NavItem>
                                <a href="/consultar" class="list-group-item text-white">                         
                                <Media object src={IcoConsultar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                                Consultar
                                </a>
                                </NavItem>
                                <NavItem>
                                <a href="/validar" class="list-group-item text-white">                         
                                <Media object src={IcoValidar} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                                Validar
                                </a>
                                </NavItem>
                                <NavItem>
                                <a href="/admin" class="list-group-item text-white">                         
                                <Media object src={IcoAdministrador} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                                Administración
                                </a>
                                </NavItem>
                                <NavItem>
                                <a href="/configuraciones" class="list-group-item text-white">                         
                                <Media object src={IcoConfiguracion} style={{maxHeigth:'2em', maxWidth:'2em', marginRight:'1em'}}/>
                                Configuración
                                </a>
                                </NavItem>
                                </Nav>
                              </Collapse>
                            </Navbar>
                            </div>
                );

                // list-group-item-action
        default: 
            return(
                <div></div>
            )
    }
}

export default Navigation
